import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import NavLinks from '../../meet/NavLinks';
import MyMeetsNavLinks from '../../myMeets/MyMeetsNavLinks';
import MyAthleteEntryNavLinks from '../../myAthleteEntry/MyAthleteEntryNavLinks';

import useOmeMeetData from '../../../state/omeMeet/UseOmeMeetData';
import useOrgUnitAthleteEntryInfoData from '../../../state/orgUnitAthleteEntryInfo/UseOrgUnitAthleteEntryInfoData';
import UseOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData from '../../../state/omeMeetOrgUnitAthleteEntryIndividualRosterEntry/UseOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData';
import useOmeMeetOrgUnitEntryData from '../../../state/omeMeetOrgUnitEntry/UseOmeMeetOrgUnitEntryData';
import useAthleteEntryContextData from '../../../state/athleteEntryContextView/UseAthleteEntryContextData';
import useMyAthleteMeetEntriesFiltersData from '../../../state/myAthleteMeetEntriesFilters/UseMyAthleteMeetEntriesFiltersData';

import useSearchMeetData from '@usas/ui-web/state/searchMeet/UseSearchMeetData';
import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';

const useAthleteEntryContextView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { omeMeetState } = useOmeMeetData();
  const { clearOmeMeetOrgUnitEntryObjData } = useOmeMeetOrgUnitEntryData();
  const { clearOrgUnitAthleteEntryInfoObjData } = useOrgUnitAthleteEntryInfoData();
  const { omeMeetOrgUnitAthleteEntryIndividualRosterEntryState, clearOmeMeetOrgUnitAthleteEntryIndividualRosterEntryObjData }
    = UseOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData();
  const { searchMeetState, setSearchMeetState } = useSearchMeetData();
  const { selectOrgUnitState } = useSelectOrgUnitData();
  const { athleteEntryContextState, setAthleteEntryContextState } = useAthleteEntryContextData();
  const { myAthleteMeetEntriesFiltersState } = useMyAthleteMeetEntriesFiltersData();
  const [state, setState] = useState({ orgUnitRegistrationStartDate: '', orgUnitRegistrationEndDate: '', orgUnitName: '' });
  const BACK_TO_LABELS = {
    entryBackToLabel: selectOrgUnitState.orgUnitId === '' ? 'Back to My Athlete Meet Entries' : omeMeetState.route === '' ? 'Back to My Meets' : 'Back to Athlete Entry Management',
  };

  const onBackClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    clearOmeMeetOrgUnitEntryObjData();
    clearOrgUnitAthleteEntryInfoObjData();
    clearOmeMeetOrgUnitAthleteEntryIndividualRosterEntryObjData();

    if (omeMeetState.route === '') {
      if (selectOrgUnitState.orgUnitId === '') {
        //My Athlete Meet Entries Route
        navigate(MyAthleteEntryNavLinks.MY_ATHLETE_ENTRY, { state: { myAthleteMeetEntriesFiltersState: myAthleteMeetEntriesFiltersState } });
      }
      else {
        //OME Route
        navigate(MyMeetsNavLinks.MEET_ENTRY_ATHLETE, { state: { selectOrgUnitState: selectOrgUnitState } });
      }
    }
    else {
      //Meet Route
      setSearchMeetState({ ...searchMeetState, showMeetHeader: true });

      navigate(NavLinks.MEET_ENTRY_ATHLETE, { state: { goToMeet: true } });
    }
  };

  useEffect(() => {
    setAthleteEntryContextState({
      ...athleteEntryContextState, isReadOnly: location.state?.isReadOnly ?? true,
      isUnattached: location?.state?.orgUnitName?.substring(0, 10) === 'Unattached' ? true : false
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (location.state) {
      setState({
        ...state,
        orgUnitRegistrationStartDate: location.state?.orgUnitRegistrationStartDate || '',
        orgUnitRegistrationEndDate: location.state?.orgUnitRegistrationEndDate || '',
        orgUnitName: location.state?.orgUnitName || ''
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function getBackToLabel() {
    return BACK_TO_LABELS.entryBackToLabel;
  }

  return {
    omeMeetOrgUnitAthleteEntryIndividualRosterEntryState,
    backToLabel: getBackToLabel(),
    onBackClicked
  };
};

export default useAthleteEntryContextView;